/**
 * @file
 * Sodexo navigatio search block functionality
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.sxoSearch = {

    headerSearch: function (context) {
      // Changing placeholder on header search field depending on window width
      var language = $('HTML').attr('lang');
      var translationsHeader = {
        fi: "Löydä ravintola",
        en: "Find a restaurant"
      };

      var textFieldInputHeader = $("#block-restaurant-searchfield-navigation .form-item-search-api-fulltext input[type=text]"),
        placeholderHeader = translationsHeader[language];

      $(textFieldInputHeader).each(function () {
        $(this).data("placeholder", $(this).attr("placeholder"));
      });

      $(window).on("resize load", function () {
        if ($(window).width() <= 719) {
          textFieldInputHeader.attr("placeholder", placeholderHeader);
        } else {
          $(textFieldInputHeader).each(function () {
            $(this).attr("placeholder", $(this).data("placeholder"));
          });
        }
      });
    },

    frontPageSearch: function (context) {
      // Changing placeholder on front page search field depending on window width
      var language = $('HTML').attr('lang');
      var translations = {
        fi: "Paikkakunta, osoite tai ravintola",
        en: "Town, address or restaurant"
      };
      var translationsSmall = {
        fi: "Löydä ravintola",
        en: "Find a restaurant"
      };


      var textFieldInput = $("#block-restaurant-searchfield-front .form-item-search-api-fulltext input[type=text]"),
        placeholder = translations[language],
        placeholderSmall = translationsSmall[language];

      $(textFieldInput).each(function () {
        $(this).data("placeholder", $(this).attr("placeholder"));
      });

      $(window).on("resize load", function () {
        if ($(window).width() > 374 && $(window).width() < 720) {
          textFieldInput.attr("placeholder", placeholder);
        } else if ($(window).width() <= 374) {
          textFieldInput.attr("placeholder", placeholderSmall);
        } else {
          $(textFieldInput).each(function () {
            $(this).attr("placeholder", $(this).data("placeholder"));
          });
        }
      });
    },

    restaurantListingSearch: function (context) {
      var language = $('HTML').attr('lang');
      var restaurantSearch = {
        fi: "Löydä ravintola",
        en: "Find a restaurant"
      },
        lunchSearch = {
          fi: "Löydä lounasravintola",
          en: "Find a lunch restaurant"
        },
        studentSearch = {
          fi: "Löydä opiskelijaravintola",
          en: "Find a student restaurant"
        },
        cafeSearch = {
          fi: "Löydä kahvila",
          en: "Find a café"
        },
        meetingSearch = {
          fi: "Löydä tapahtumatilat",
          en: "Find event venues"
        };
      var allListing = $("#views-exposed-form-restaurant-all-restaurants .form-item-combine input[type=text]"),
        restaurantListing = $("#views-exposed-form-restaurant-listing-restaurants-by-venuetype .form-item-combine input[type=text]"),
        meetingListing = $("#block-views-block-meetings-and-events-meetings-party-venues-2 .form-item-combine input[type=text]"),
        phrestaurantSearch = restaurantSearch[language],
        phlunchSearch = lunchSearch[language],
        phstudentSearch = studentSearch[language],
        phcafeSearch = cafeSearch[language],
        phmeetingSearch = meetingSearch[language];

      $(allListing).each(function () {
        $(this).data("placeholder", $(this).attr("placeholder"));
      });

      $(restaurantListing).each(function () {
        $(this).data("placeholder", $(this).attr("placeholder"));
      });

      $(meetingListing).each(function () {
        $(this).data("placeholder", $(this).attr("placeholder"));
      });

      $(window).on("resize load", function () {
        if ($(window).width() <= 719) {
          allListing.attr("placeholder", phrestaurantSearch);
          if ($(".header-search-title .field--name-field-search-field-label:contains('lounasravintola')").length > 0 || $(".header-search-title .field--name-field-search-field-label:contains('lunch')").length > 0) {
            restaurantListing.attr("placeholder", phlunchSearch);
          } else if ($(".header-search-title .field--name-field-search-field-label:contains('opiskelijaravintola')").length > 0 || $(".header-search-title .field--name-field-search-field-label:contains('student')").length > 0) {
            restaurantListing.attr("placeholder", phstudentSearch);
          } else if ($(".header-search-title .field--name-field-search-field-label:contains('kahvila')").length > 0 || $(".header-search-title .field--name-field-search-field-label:contains('café')").length > 0) {
            restaurantListing.attr("placeholder", phcafeSearch);
          } else if ($(".header-search-title .field--name-field-search-field-label:contains('kokous')").length > 0 || $(".header-search-title .field--name-field-search-field-label:contains('meeting')").length > 0) {
            meetingListing.attr("placeholder", phmeetingSearch);
          }
        } else {
          $(allListing).each(function () {
            $(this).attr("placeholder", $(this).data("placeholder"));
          });
          $(restaurantListing).each(function () {
            $(this).attr("placeholder", $(this).data("placeholder"));
          });
          $(meetingListing).each(function () {
            $(this).attr("placeholder", $(this).data("placeholder"));
          });
        }
      });


    },

    attach: function (context, settings) {
      Drupal.behaviors.sxoSearch.headerSearch();
      Drupal.behaviors.sxoSearch.frontPageSearch();
      Drupal.behaviors.sxoSearch.restaurantListingSearch();

      $(context).find(".main-navigation--main--wrapper--right .main-navigation--main--wrapper--right--search .search-icon").click(function (event) {
        event.preventDefault();
        $(".main-navigation--main--wrapper--right .main-navigation--main--wrapper--right--search").toggleClass("search-hidden search-show");

        // Opening search field above mobile menu
        $(".main-navigation--main--wrapper--right").each(function () {
          $(this).toggleClass("search-show");
          $(this).removeClass("search-hidden");

          if (!$(this).hasClass("search-show")) {
            $(this).addClass("search-hidden");
          }
        });

      });
    }
  };

})(jQuery, Drupal);
